var _path, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.49469 2.65801C3.59794 1.19003 4.81318 0 6.2144 0H6.77388C8.17269 0 9.39033 1.18989 9.49359 2.65801L9.51497 2.96203H12.4941V15.6H0.494141V2.96203H3.47331L3.49469 2.65801ZM4.43685 2.96203H8.55143C8.48268 2.01924 7.66191 0.962025 6.73015 0.962025H6.25813C5.32514 0.962025 4.50565 2.01844 4.43685 2.96203Z",
    fill: "#E6E6E6"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.49469 2.65801C3.59794 1.19003 4.81318 0 6.2144 0H6.77388C8.17269 0 9.39033 1.18989 9.49359 2.65801L9.51497 2.96203H12.4941V15.6H0.494141V2.96203H3.47331L3.49469 2.65801ZM4.43685 2.96203H8.55143C8.48268 2.01924 7.66191 0.962025 6.73015 0.962025H6.25813C5.32514 0.962025 4.50565 2.01844 4.43685 2.96203Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCart);
export default __webpack_public_path__ + "static/media/icon-cart.c1bd91fc524b1a6f4d7e2763bb4803f1.svg";
export { ForwardRef as ReactComponent };